import { useId, useRef, type ReactNode } from "react";
import { useDialog } from "../hooks/useDialog";
import { Icons } from "./Icons";

/** Coquille commune des modales (scrim + carte + head + body). Le contenu
 * spécifique (erreur, formulaire, actions) est passé en children. */
export function Sheet({
  title,
  onClose,
  children,
  footer,
  nested,
}: {
  title: ReactNode;
  onClose: () => void;
  children: ReactNode;
  /** Rendu hors du corps défilant, donc épinglé en bas de la carte. */
  footer?: ReactNode;
  /** Empilée par-dessus une autre modale (ex: ouverte depuis .activity-modal) : passe au-dessus en z-index. */
  nested?: boolean;
}) {
  const ref = useRef<HTMLDivElement>(null);
  const titleId = useId();
  useDialog(ref, onClose);
  return (
    <>
      <div
        className={nested ? "scrim scrim--nested" : "scrim"}
        onClick={onClose}
      />
      <div
        className={nested ? "sheet sheet--nested" : "sheet"}
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        tabIndex={-1}
        ref={ref}
      >
        <div className="head">
          <h2 id={titleId}>{title}</h2>
          <button className="close" onClick={onClose} aria-label="Fermer">
            <Icons.close size={16} sw={2} />
          </button>
        </div>
        <div className="body">{children}</div>
        {footer}
      </div>
    </>
  );
}

export default Sheet;
